var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessEsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7575_15273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 16.9543 16.9543 8 28 8C39.0457 8 48 16.9543 48 28C48 39.0457 39.0457 48 28 48C16.9543 48 8 39.0457 8 28Z",
    fill: "#F1D6D6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7575_15273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6667 25.75C35.1049 25.7695 34.5465 25.8457 34 25.9775C33.9501 24.906 33.4893 23.8948 32.7134 23.1542C31.9375 22.4135 30.906 22.0001 29.8333 22H29.6067C29.7386 21.4536 29.8146 20.8951 29.8333 20.3333C29.8333 19.4493 29.4821 18.6014 28.857 17.9763C28.2319 17.3512 27.3841 17 26.5 17C25.6159 17 24.7681 17.3512 24.143 17.9763C23.5179 18.6014 23.1667 19.4493 23.1667 20.3333C23.1854 20.8951 23.2614 21.4536 23.3933 22H23.1667C22.0616 22 21.0018 22.439 20.2204 23.2204C19.439 24.0018 19 25.0616 19 26.1667V32.8333C19 33.3805 19.1078 33.9223 19.3172 34.4278C19.5266 34.9334 19.8335 35.3927 20.2204 35.7796C21.0018 36.561 22.0616 37 23.1667 37H24.1867C24.2858 37.0004 24.3837 36.9779 24.4727 36.9342C24.5617 36.8906 24.6394 36.8269 24.6997 36.7483C24.7601 36.6696 24.8014 36.5781 24.8206 36.4808C24.8397 36.3835 24.8361 36.2831 24.81 36.1875C24.5192 35.1383 24 34.5 24 33.6667C24 33.0036 24.2634 32.3677 24.7322 31.8989C25.2011 31.4301 25.837 31.1667 26.5 31.1667C27.163 31.1667 27.7989 31.4301 28.2678 31.8989C28.7366 32.3677 29 33.0036 29 33.6667C29 34.5 28.4733 35.14 28.1892 36.1908C28.1637 36.2863 28.1606 36.3863 28.18 36.4831C28.1994 36.58 28.2408 36.671 28.3011 36.7493C28.3614 36.8275 28.4389 36.8908 28.5275 36.9343C28.6162 36.9778 28.7137 37.0003 28.8125 37H29.8333C30.3805 37 30.9223 36.8922 31.4278 36.6828C31.9334 36.4734 32.3927 36.1665 32.7796 35.7796C33.1665 35.3927 33.4734 34.9334 33.6828 34.4278C33.8922 33.9223 34 33.3805 34 32.8333V32.19C34.5465 32.3215 35.1049 32.3974 35.6667 32.4167C36.5507 32.4167 37.3986 32.0655 38.0237 31.4404C38.6488 30.8152 39 29.9674 39 29.0833C39 28.1993 38.6488 27.3514 38.0237 26.7263C37.3986 26.1012 36.5507 25.75 35.6667 25.75Z",
    fill: "#374151"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7575_15273",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.454902 0 0 0 0 0.72549 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7575_15273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7575_15273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7575_15273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(19 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessEsg);
export default __webpack_public_path__ + "static/media/businessEsg.a74bdf37f1a114f602394b7b6a58f9bf.svg";
export { ForwardRef as ReactComponent };